import React, { useEffect, useMemo } from 'react';
import { useStore } from 'effector-react';
import { type HSIconMark, MediaType } from '@types';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import FeatureToggle from '@components/FeatureToggle';
import { $playerWidgetsApi } from '@stores/playerWidgets';
import Button from '@components/Button';
import ImageContainer from '@components/ImageContainer';
import { getSysUrl, getUrlByMediaType } from '@utils/urlMakers';
import Tip from '@components/Tip';
import { Dropdown, type DropdownItem } from '@components/Dropdown';
import { HOTSPOT_MARK_ICONS, reAddEditingHotspot } from '../../../../hotspot';
import { selectLibIcons } from '../../../../mediaLib';
import StickSetting from '../StickSetting';

const lineTypeItems: DropdownItem<HSIconMark['lineType']>[] = [
  { id: 0, name: '直线' },
  { id: 1, name: '三角形' },
  // { id: 2, name: '圆形端点线' },
  // { id: 3, name: '圆环端点线' },
];

function IconSettingMark() {
  const { hotspot } = useStore($editingHotspot)!;
  const icon = hotspot.icon as HSIconMark;

  const src = useMemo(() => {
    if (icon.media?.enabled && icon.media.url) {
      return getUrlByMediaType(icon.media.type!, icon.media.url);
    }
    if (!icon.media && HOTSPOT_MARK_ICONS[hotspot.data.code]) {
      return getSysUrl(HOTSPOT_MARK_ICONS[hotspot.data.code]);
    }
    return '';
  }, [icon.media, hotspot.data.code]);

  useEffect(() => {
    return () => {
      $playerWidgetsApi.remove('mark');
    };
  }, []);

  const handleSelectIcon = async () => {
    const { sysItems, libItems } = await selectLibIcons({
      withLib: true,
      staticOnly: true,
    });
    if (sysItems) {
      const item = sysItems[0];
      $editingHotspotApi.update((draft) => {
        const iconData = draft.icon as HSIconMark;
        iconData.media ??= { enabled: 1 };
        iconData.media.type = MediaType.system;
        iconData.media.url = item.url;
        iconData.media.id = 0;
      });
      reAddEditingHotspot();
    } else if (libItems) {
      const item = libItems[0];
      $editingHotspotApi.update((draft) => {
        const iconData = draft.icon as HSIconMark;
        iconData.media ??= { enabled: 1 };
        iconData.media.type = MediaType.lib;
        iconData.media.url = item.url;
        iconData.media.id = item.id;
      });
      reAddEditingHotspot();
    }
  };

  return (
    <>
      <div className="mt-20">标记样式</div>
      <Dropdown
        className="mt-10"
        selected={icon.lineType ?? 0}
        items={lineTypeItems}
        onChange={(typeId) => {
          $editingHotspotApi.update((draft) => {
            (draft.icon as HSIconMark).lineType = typeId;
          });
        }}
      />
      <FeatureToggle
        className="mt-20"
        title="标记图标"
        isOn={!!src}
        onToggle={(bool) => {
          $editingHotspotApi.update((draft) => {
            (draft.icon as HSIconMark).media = bool
              ? {
                  enabled: 1,
                  url: '/hotspots/system/changjingqiehuan/qianjin1.png',
                  type: MediaType.system,
                  id: 0,
                }
              : { enabled: 0 };
          });
        }}
      />
      {!!src && (
        <>
          <ImageContainer className="mt-10 h-70">
            <div
              className="h-40 w-40 bg-cover bg-no-repeat"
              style={{ backgroundImage: `url(${src})` }}
            />
          </ImageContainer>
          <div className="mt-10 flex items-center justify-between">
            <Tip>官方精选图标库</Tip>
            <Button size="sm" onClick={handleSelectIcon}>
              选择图标
            </Button>
          </div>
        </>
      )}
      <StickSetting />
      <Button
        className="mt-20 w-full"
        onClick={() => $playerWidgetsApi.add('mark')}
      >
        标记线高级设置
      </Button>
    </>
  );
}

export default IconSettingMark;
